import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  stepper: {
    marginLeft: -theme.spacing(6),
    overflow: 'hidden',
    textAlign: 'left',
    '& .MuiPaper-root': {
      background: 'transparent',
      marginLeft: '5vw',
    },
    '& .MuiStepLabel-label': {
      color: theme.palette.text.title,
      fontSize: 21,
      fontWeight: '500',
    },
    '& .Mui-disabled .MuiStepIcon-root': {
      border: `1px solid ${theme.palette.text.title}`,
      borderRadius: '50%',
      color: 'white',
      stroke: theme.palette.text.title,
    },
  },
}));
